var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Layout, MessageBanner, Modal, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useMutation, useQueryClient } from "react-query";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekSelection } from "../inputs";
import { readMergeError } from "../../utils/titleMergeErrors";
import { invalidateAfterTitleMerge } from "../../utils/titleMergeQueries";
import { mergeProvisionalTitle } from "../../api/titleService";
import { useProvisionalMergeCandidates } from "../../hooks/useProvisionalMergeCandidates";
var candidateLabel = function (candidate) {
    var _a;
    var parts = [
        candidate.mainTitle,
        candidate.firstContributor,
        candidate.publisher,
        candidate.isbn,
        (_a = candidate.publicationYear) === null || _a === void 0 ? void 0 : _a.toString(),
    ];
    return parts.filter(Boolean).join(" - ");
};
export var MergeProvisionalTitleModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, onMerged = _a.onMerged, provisionalId = _a.provisionalId, provisionalName = _a.provisionalName, titleType = _a.titleType;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _b = useState(""), searchQuery = _b[0], setSearchQuery = _b[1];
    var _c = useState(""), selectedTargetId = _c[0], setSelectedTargetId = _c[1];
    var _d = useState(null), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = useProvisionalMergeCandidates(provisionalId, searchQuery, titleType), candidates = _e.candidates, isCandidatesLoading = _e.isCandidatesLoading;
    useEffect(function () {
        if (!open) {
            setSearchQuery("");
            setSelectedTargetId("");
            setErrorMessage(null);
        }
    }, [open]);
    var candidateOptions = useMemo(function () { return __spreadArray([
        {
            value: "",
            label: formatMessage({
                id: "ui-br-legaldeposits.provisionalTitle.merge.field.targetEmpty",
            }),
        }
    ], candidates
        .filter(function (candidate) { return !!candidate.id; })
        .map(function (candidate) { return ({
        value: candidate.id,
        label: candidateLabel(candidate),
    }); }), true); }, [candidates, formatMessage]);
    var mapMergeError = useCallback(function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, status, code;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, readMergeError(error)];
                case 1:
                    _a = _b.sent(), status = _a.status, code = _a.code;
                    if (code === "TARGET_PROVISIONAL") {
                        return [2 /*return*/, formatMessage({
                                id: "ui-br-legaldeposits.provisionalTitle.merge.error.targetProvisional",
                            })];
                    }
                    if (code === "DIFFERENT_TITLE_TYPES") {
                        return [2 /*return*/, formatMessage({
                                id: "ui-br-legaldeposits.provisionalTitle.merge.error.differentTypes",
                            })];
                    }
                    if (code === "AGENDA_CONFLICT") {
                        return [2 /*return*/, formatMessage({
                                id: "ui-br-legaldeposits.provisionalTitle.merge.error.agendaConflict",
                            })];
                    }
                    if (code === "SPECIAL_ISSUE_LINK_CONFLICT") {
                        return [2 /*return*/, formatMessage({
                                id: "ui-br-legaldeposits.provisionalTitle.merge.error.specialIssueLinkConflict",
                            })];
                    }
                    if (code === "MERGE_REFUSED" || status === 409) {
                        return [2 /*return*/, formatMessage({
                                id: "ui-br-legaldeposits.provisionalTitle.merge.error.refused",
                            })];
                    }
                    if (status === 403) {
                        return [2 /*return*/, formatMessage({
                                id: "ui-br-legaldeposits.provisionalTitle.merge.error.forbidden",
                            })];
                    }
                    return [2 /*return*/, formatMessage({
                            id: "ui-br-legaldeposits.provisionalTitle.merge.error.generic",
                        })];
            }
        });
    }); }, [formatMessage]);
    var mergeMutation = useMutation(function (targetId) {
        return mergeProvisionalTitle(kyInstance, provisionalId, targetId);
    }, {
        onSuccess: function () {
            invalidateAfterTitleMerge(queryClient);
            onMerged();
            onClose();
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = setErrorMessage;
                        return [4 /*yield*/, mapMergeError(error)];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleConfirm = useCallback(function () {
        setErrorMessage(null);
        mergeMutation.mutate(selectedTargetId);
    }, [mergeMutation, selectedTargetId]);
    return (React.createElement(Modal, { open: open, label: formatMessage({
            id: "ui-br-legaldeposits.provisionalTitle.merge.modalTitle",
        }), onClose: onClose, size: "small", footer: React.createElement(Layout, { className: "display-flex justify-end" },
            React.createElement(Button, { disabled: mergeMutation.isLoading, onClick: onClose },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" })),
            React.createElement(Button, { buttonStyle: "primary", disabled: !selectedTargetId || mergeMutation.isLoading, onClick: handleConfirm },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.provisionalTitle.merge.confirm.button" }))) },
        React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.provisionalTitle.merge.warning" })),
        provisionalName && (React.createElement(Layout, { className: "marginTop1" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.provisionalTitle.merge.source", values: { name: provisionalName } }))),
        React.createElement(RecekSelection, { labelId: "ui-br-legaldeposits.provisionalTitle.merge.field.target", name: "mergeTargetId", value: selectedTargetId, asyncFilter: true, loading: isCandidatesLoading, onFilter: function (value) { return setSearchQuery(value); }, onChange: function (id) { return setSelectedTargetId(id); }, dataOptions: candidateOptions, marginBottom0: true }),
        errorMessage && (React.createElement(Layout, { className: "marginTop1" },
            React.createElement(MessageBanner, { type: "error" }, errorMessage)))));
};
